import { createSelector } from 'reselect';
import { MANAGE_SERVICES_TAB } from 'constants/logic';
import { practitioners, resources, services } from 'store/saga/entities/bound';
import { selectRouteParams } from 'selectors/general';

export const selectTabFirstItemId = createSelector(
  state => state || {},
  (state, tab, venueId) => ({ tab, venueId }),
  selectRouteParams,
  (state, { tab, venueId: passedVenueId }, { venueId: routeVenueId }) => {
    const venueId = passedVenueId || routeVenueId;
    let items;
    switch (tab) {
      case MANAGE_SERVICES_TAB.PRACTITIONERS:
        items = practitioners.loaded(state, venueId) ? practitioners.data(state, venueId) : [];
        break;
      case MANAGE_SERVICES_TAB.RESOURCES:
        items = resources.loaded(state, venueId) ? resources.data(state, venueId) : [];
        break;
      case MANAGE_SERVICES_TAB.SERVICES:
        items = services.loaded(state, venueId) ? services.data(state, venueId) : [];
        break;
      default:
        items = [];
        break;
    }
    return items.length ? items[0].id : null;
  }
);
